<template>
  <div
    v-click-outside="close"
    class="filter-dropdown position-relative"
  >
    <button
      type="button"
      class="filter-dropdown-toggle d-flex align-items-center gap-1"
      :class="{ 'has-value': value !== null }"
      @click="open = !open"
    >
      <span class="filter-dropdown-label">{{ displayLabel }}</span>
      <font-awesome-icon
        :icon="['fas', open ? 'chevron-up' : 'chevron-down']"
        class="filter-dropdown-chevron"
      />
    </button>
    <transition name="slide">
      <div
        v-if="open && options.length > 0"
        class="filter-dropdown-menu position-absolute"
      >
        <div
          class="filter-dropdown-item"
          :class="{ active: value === null }"
          @click="select(null)"
        >
          {{ placeholder }}
        </div>
        <div
          v-for="option in options"
          :key="option.value"
          class="filter-dropdown-item"
          :class="{ active: value === option.value }"
          @click="select(option.value)"
        >
          {{ option.label }}
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';

export default {
  name: 'FilterDropdown',
  directives: { ClickOutside },
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    placeholder: {
      type: String,
      default: 'Tous',
    },
    options: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['input'],
  data() {
    return { open: false };
  },
  computed: {
    displayLabel() {
      if (this.value === null) return this.placeholder;
      const found = this.options.find((o) => o.value === this.value);
      return found ? found.label : this.placeholder;
    },
  },
  methods: {
    select(value) {
      this.open = false;
      this.$emit('input', value);
    },
    close() {
      this.open = false;
    },
  },
};
</script>

<style scoped>
.filter-dropdown-toggle {
  background: transparent;
  border: 1.5px solid var(--bs-gray-400);
  border-radius: 9999px;
  padding: 4px 12px;
  font-size: 1rem;
  font-weight: 600;
  color: var(--bs-blue-700);
  cursor: pointer;
  white-space: nowrap;
  transition: border-color 0.2s, background-color 0.2s;
  line-height: 1.4;
}
.filter-dropdown-toggle:hover {
  border-color: var(--bs-blue-300);
}
.filter-dropdown-toggle.has-value {
  background-color: var(--bs-blue-700);
  border-color: var(--bs-blue-700);
  color: #fff;
}
.filter-dropdown-chevron {
  width: 10px;
  height: 10px;
}
.filter-dropdown-menu {
  top: calc(100% + 6px);
  left: 50%;
  transform: translateX(-50%);
  min-width: 160px;
  max-height: 220px;
  overflow-y: auto;
  background: #fff;
  border: 1px solid var(--bs-gray-300);
  border-radius: 10px;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.10);
  z-index: 20;
  padding: 4px 0;
}
.filter-dropdown-item {
  padding: 6px 14px;
  font-size: 1rem;
  font-weight: 500;
  color: var(--bs-gray-700);
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.15s;
}
.filter-dropdown-item:hover {
  background-color: var(--bs-gray-200);
}
.filter-dropdown-item.active {
  color: var(--bs-blue-700);
  font-weight: 700;
}
.slide-enter-active,
.slide-leave-active {
  transition: opacity 0.15s, transform 0.15s;
}
.slide-enter-from,
.slide-leave-to {
  opacity: 0;
  transform: translateX(-50%) translateY(-4px);
}
</style>
